// Runs on the product page. A click opens or reuses one same-store Studio.
// Sever the opener on the initial empty document, before loading any Studio code.
(() => {
  const prefix='ceika.studio.v2.';
  let handle,active,channel;
  function finish(data){
    if(data?.type!=='ceika:studio-finish'||!active||data.key!==active.key||JSON.stringify(active.root.ceikaStudioSetup)!==active.signature)return;
    active.root.dispatchEvent(new CustomEvent('ceika:standalone-finish',{detail:data.detail}));
    active.signature=JSON.stringify(active.root.ceikaStudioSetup);
  }
  function mount(root){
    if(root.dataset.studioMounted)return;
    root.dataset.studioMounted='true';
    const button=root.querySelector('[data-studio-launch]');
    const status=root.querySelector('[data-bbk-studio-status]')||root.querySelector('[role=status]');
    button.addEventListener('click',async()=>{
      const value=root.ceikaStudioSetup;
      if(!value||value.unavailable){status.textContent=value?.unavailable||'Select a kit to open the Studio.';return;}
      let name;
      try{
        const scope=prefix+root.dataset.studioStore+'.'+root.dataset.studioTheme;
        name=localStorage.getItem(scope)||('ceikaStudio_'+crypto.randomUUID().replaceAll('-',''));
        localStorage.setItem(scope,name);
        const key=crypto.randomUUID(), now=Date.now();
        const lineage=sessionStorage.getItem(prefix+'source')||crypto.randomUUID();sessionStorage.setItem(prefix+'source',lineage);
        const context={key,name,lineage,at:now,store:root.dataset.studioStore,product:root.dataset.productId,
          locale:document.documentElement.lang,productURL:location.href,setup:value};
        // Expire handoffs without keeping customer selections indefinitely.
        for(const k of Object.keys(localStorage).filter(k=>k.startsWith(prefix+'launch.'))){
          try{if(now-JSON.parse(localStorage.getItem(k)).at>24*3600000)localStorage.removeItem(k);}catch{localStorage.removeItem(k);}
        }
        localStorage.setItem(prefix+'launch.'+key,JSON.stringify(context));
        const dest=new URL(location.href);dest.searchParams.set('view','ceika-studio');dest.hash=key;
        active={key,root,signature:JSON.stringify(value)};
        if((!handle||handle.closed)&&typeof BroadcastChannel==='function'&&navigator.locks?.query){
          // Unrelated browsing context groups cannot target each other's named windows.
          // Ask the holder of this origin/store's lock to receive this user click.
          const holder=localStorage.getItem(name+'.lineage');
          if(holder&&holder!==lineage){
            const locks=await navigator.locks.query();
            if(locks.held.some(lock=>lock.name===name)){
              channel?.close();channel=new BroadcastChannel(name);
              channel.onmessage=e=>{if(e.data?.key!==active?.key)return;
                if(e.data.type==='ceika:studio-focused')status.textContent=e.data.visible?'Studio opened in its own tab.':'Your Studio is already open. Switch to its tab to continue.';
                else finish(e.data);};
              channel.postMessage({type:'ceika:open-studio',name,key});
              status.textContent='Opening your existing Studio tab…';return;
            }
          }
        }
        if(!handle||handle.closed)handle=window.open('',name);
        if(!handle){
          context.lineage='isolated-'+key;localStorage.setItem(prefix+'launch.'+key,JSON.stringify(context));
          const link=document.createElement('a');link.href=dest.href;link.target='_blank';link.rel='noopener';link.textContent='Open Studio in a new tab';
          status.replaceChildren('Your browser blocked the Studio tab. ',link);return;
        }
        try{
          handle.opener=null;
          if(handle.location.origin===location.origin&&handle.CEIKAStudioHost?.name===name){
            handle.postMessage({type:'ceika:open-studio',key,name},location.origin);
          }else if(handle.location.href==='about:blank'||handle.location.origin===location.origin){
            handle.location.replace(dest.href);
            const target=handle;const until=Date.now()+30000;
            const handshake=setInterval(()=>{try{
              if(target.closed||active?.key!==key||Date.now()>until){clearInterval(handshake);return;}
              if(target.location.origin===location.origin&&target.CEIKAStudioHost?.name===name){
                clearInterval(handshake);target.postMessage({type:'ceika:open-studio',key,name},location.origin);
              }
            }catch{clearInterval(handshake);}},80);
          }else throw Error('Studio tab is unavailable.');
          handle.focus();
          status.textContent='Studio opened in its own tab.';
        }catch{handle=null;status.textContent='The Studio tab could not be opened. Try again.';}
      }catch{status.textContent='Allow this store to save its Studio setup, then try again.';}
    });
  }
  window.addEventListener('message',event=>{
    if(event.origin!==location.origin||event.source!==handle||!active||event.data?.key!==active.key)return;
    finish(event.data);
  });
  document.querySelectorAll('[data-ceika-studio]').forEach(mount);
  window.CEIKAStudioEmbed={mount,open(root){root.querySelector('[data-studio-launch]')?.click();}};
})();
